import script from "./MediaInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaInput.vue?vue&type=script&lang=ts&setup=true"

import "./MediaInput.vue?vue&type=style&index=0&id=1a83abb8&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a83abb8"]])

export default __exports__